import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { RuntimeService } from '../../services/runtime/runtime.service';

export const COMPANY_ID_HEADER = 'X-Company-Id';

export const headerCompanyIdInterceptor: HttpInterceptorFn = (req, next) => {
    if (req.url.startsWith(environment.CORE_SVC_AUTH_URL)) {
        return next(req);
    }

    const runtimeService = inject(RuntimeService);
    const companyId = runtimeService.tenantId() ?? runtimeService.runtimeCustomerKey();

    if (!companyId) {
        return next(req);
    }

    const modifiedReq = req.clone({
        headers: req.headers.set(COMPANY_ID_HEADER, companyId),
    });

    return next(modifiedReq);
};
